"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputControl = void 0;
const React = require("react");
class InputControl extends React.Component {
    constructor(props) {
        super(props);
    }
}
exports.InputControl = InputControl;
InputControl.defaultProps = { validateRules: [] };
